import React from 'react';
import PropTypes from 'prop-types';
import ImageBlock from 'components/image-block';
import RichText from 'components/rich-text';
import cn from 'classnames';

const StoryBlock = ({
  heading,
  textHtml,
  backgroundColor = '#EAF4FA',
  textColor = '#00004F',
  image,
}) => {
  return (
    <div
      className={cn('story-block', {
        'story-block_no-image': !image,
      })}
      style={{ backgroundColor: backgroundColor, color: textColor }}
    >
      <div className="story-block__container">
        <div className="story-block__content">
          {heading && (
            <strong className="story-block__heading story-block__heading_mobile">
              {heading}
            </strong>
          )}
          {image && (
            <div className="story-block__image-container">
              <ImageBlock
                {...image}
                className="image-block_local"
                imageClassName="image_size_story-block"
              />
            </div>
          )}
          <div className="story-block__text-container">
            {heading && (
              <h2
                className="story-block__heading"
                data-anchor-parent="story-block"
              >
                {heading}
              </h2>
            )}
            <RichText text={textHtml} className="rich-text_in-story-block" />
          </div>
        </div>
      </div>
    </div>
  );
};

StoryBlock.propTypes = {
  heading: PropTypes.string,
  textHtml: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  image: PropTypes.exact(ImageBlock.propTypes),
};

export default StoryBlock;
